/*
 * Delivery question (SES, 2026-09-23) -- see snippets/delivery-question.liquid.
 *
 * 1. When the customer answers, save it as cart attributes so it survives the
 *    drawer re-rendering and shows on the order in admin.
 * 2. When they click Checkout (drawer or cart page), stamp the answer onto EVERY
 *    cart line as hidden properties `_delivery` / `_tailgate` -- those are what
 *    Shopify passes to our shipping calculator -- then continue to checkout.
 *    If the question is showing and unanswered, stop and ask.
 *
 * Event delegation on document throughout, because the theme re-renders the
 * drawer's HTML whenever the cart changes.
 */
(function () {
  'use strict';

  function answerFrom(box) {
    var where = box.querySelector('input[name="dq_where"]:checked');
    var dock = box.querySelector('input[name="dq_dock"]:checked');
    if (!where) return null;
    if (where.value === 'Residence') {
      return { attrs: { 'Delivery location': 'Residence', 'Loading dock': '' },
               props: { _delivery: 'residential', _tailgate: 'yes' } };
    }
    if (!dock) return null;
    return { attrs: { 'Delivery location': 'Business', 'Loading dock': dock.value },
             props: { _delivery: 'commercial', _tailgate: dock.value === 'Yes' ? 'no' : 'yes' } };
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  // Keep every existing property and add/overwrite ours. Lines are addressed by
  // key; changing one line's properties never changes another line's key.
  function stampLines(props) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var chain = Promise.resolve();
        cart.items.forEach(function (item) {
          var cur = item.properties || {};
          if (cur._delivery === props._delivery && cur._tailgate === props._tailgate) return;
          var merged = Object.assign({}, cur, props);
          chain = chain.then(function () {
            return post('/cart/change.js', { id: item.key, quantity: item.quantity, properties: merged });
          });
        });
        return chain;
      });
  }

  function syncVisibility(box) {
    var where = box.querySelector('input[name="dq_where"]:checked');
    var dockGroup = box.querySelector('[data-dq-dock]');
    var resiNote = box.querySelector('[data-dq-resi-note]');
    if (dockGroup) dockGroup.hidden = !(where && where.value === 'Business');
    if (resiNote) resiNote.hidden = !(where && where.value === 'Residence');
  }

  function showError(box, on) {
    box.classList.toggle('is-invalid', on);
    var err = box.querySelector('[data-dq-error]');
    if (err) err.hidden = !on;
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-delivery-question]');
    if (!box) return;
    syncVisibility(box);
    showError(box, false);
    var where = box.querySelector('input[name="dq_where"]:checked');
    var dock = box.querySelector('input[name="dq_dock"]:checked');
    var attrs = { 'Delivery location': where ? where.value : '' };
    attrs['Loading dock'] = where && where.value === 'Business' && dock ? dock.value : '';
    post('/cart/update.js', { attributes: attrs }).catch(function () { /* saved again at checkout */ });
  });

  // Capture phase, so this runs before the theme's own handlers.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn || !btn.form) return;
    var box = btn.form.querySelector('[data-delivery-question]');
    if (!box) return;                         // question not shown (light cart)
    var ans = answerFrom(box);
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!ans) {
      showError(box, true);
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (btn.dataset.dqBusy) return;
    btn.dataset.dqBusy = '1';
    btn.setAttribute('aria-busy', 'true');
    var form = btn.form;
    post('/cart/update.js', { attributes: ans.attrs })
      .then(function () { return stampLines(ans.props); })
      .catch(function () { /* never block checkout; the calculator falls back to the safe default */ })
      .then(function () {
        // form.submit() skips the clicked button's name, which is what sends the
        // customer to checkout, so add it back.
        var go = document.createElement('input');
        go.type = 'hidden'; go.name = 'checkout'; go.value = '1';
        form.appendChild(go);
        form.submit();
      });
  }, true);
})();
